export default "__VITE_ASSET__e0bc8645__"